import { useEffect, useState } from "react";

import { FrmSelectFromObjects } from "components/formFields/FrmSelectFromObjects";

import { i18n } from "services/i18nService";
import { get } from "services/sosInventoryService/sosApi";
import { handleProgramError } from "services/utility/errors";

import { OBJECT_TYPES } from "appConstants";

const OBJECT_TYPE = OBJECT_TYPES.PRIORITY.fullString;

export function FrmPriority(props) {
  const {
    value,
    onValueChange,
    maxWidth,
    name = "priority",
    label = i18n("frmLabel.Priority"),
    disableClearable,
    error,
  } = props;

  const [priorities, setPriorities] = useState(null);

  useEffect(() => {
    async function retrieveRecords() {
      const { success, data, message } = await get(OBJECT_TYPE, {
        inTransaction: true,
      });
      if (success) {
        const sortedPriorities = data.records
          // secondary sort on "name"
          .sort((a, b) =>
            a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
          )
          // primary sort on "sortOrder"
          .sort((a, b) => (a.sortOrder < b.sortOrder ? -1 : 1));

        setPriorities(sortedPriorities);
      } else {
        handleProgramError(
          new Error(
            `FrmPriority | unsuccessful call to getAll, message: ${message}`
          )
        );
      }
    }
    retrieveRecords();
  }, []);

  const sortedPriorities = priorities ? priorities : null;

  return (
    <FrmSelectFromObjects
      name={name}
      options={sortedPriorities}
      value={value}
      label={label}
      onValueChange={onValueChange}
      maxWidth={maxWidth}
      error={error}
      disableClearable={disableClearable}
    />
  );
}
